import { getIcon } from '@lib/icons-definition';

function insertIcon(element: HTMLElement): void {
    if (element.dataset['iconInserted']) return;
    element.dataset['iconInserted'] = true.toString();
    element.innerHTML = getIcon(element.dataset['icon']);
    element.setAttribute('aria-hidden', 'true');
}

export function insertIcons(element: HTMLElement): void {
    if (element.dataset && element.dataset['icon']) return insertIcon(element);
    const icons = element.querySelectorAll('[data-icon]');
    Array.prototype.forEach.call(icons, insertIcon);
}
